import request from '@/utils/request'

// 手机号登录
export function loginByPhone(data) {
  return request({
    url: '/user/loginByPhone',
    method: 'post',
    data
  })
}

// 根据手机号获取核销码
export function getQrcodeByPhone(phone) {
  return request({
    url: '/user/qrcodeByPhone',
    method: 'get',
    params: { phone }
  })
}

// 更新用户关注状态
export function updateFollowStatus(phone, accountNum) {
  return request({
    url: '/user/updateFollowStatus',
    method: 'post',
    params: { phone, accountNum }
  })
}
